import AnchoredDialog from "./AnchoredDialog";

export default AnchoredDialog;
